import { showErrorDialog } from '@office-start/error-dialog-service';
export var defaultCreateErrorCallback = function (props) {
    switch (props.resultType) {
        case 'OpenNewDocFailed':
            showErrorDialog({
                category: 'CreateFile',
                error: 'OpenNewDocFailed',
                fileType: props.fileType,
                fallbackSiteUrl: props.documentWebUrl,
            });
            break;
        case 'OpenBlockedByPopupBlocker':
            showErrorDialog({
                category: 'CreateFile',
                error: 'OpenBlockedByPopupBlocker',
                fileType: props.fileType,
                fallbackSiteUrl: props.documentWebUrl,
            });
            break;
        default:
            showErrorDialog({
                category: 'CreateFile',
                error: 'Generic',
                fileType: props.fileType,
            });
    }
};
//# sourceMappingURL=defaultCreateErrorCallback.js.map